import { useGetAllMarketProductCategories } from 'api-hooks/market-product-category/use-get-all-market-product-categories'
import { useGetMarketProducts } from 'api-hooks/market-product/use-get-all-market-products'
import FilterIcon from 'assets/svg/filter-icon.svg'
import Column from 'components/atoms/column'
import Container from 'components/atoms/container'
import IconButton from 'components/atoms/icon-button'
import Row from 'components/atoms/row'
import Text from 'components/atoms/text'
import NavBar from 'components/molecules/nav-bar'
import SearchInput from 'components/molecules/search-input'
import Body from 'components/organisms/body'
import Footer from 'components/organisms/footer'
import Header from 'components/organisms/header'
import Webpage from 'components/organisms/webpage'
import CheckboxList from 'components/screens/courses/checkbox-list'
import CoursesGrid from 'components/screens/courses/courses-grid'
import SearchFiltersModal from 'components/screens/courses/search-filters-modal'
import { classNameBuilder } from 'helpers/class-name-builder'
import { useQueryParams } from 'hooks/useQueryParams'
import React from 'react'
import { MarketProductCategoryType } from 'types/market-product-category-type'
import SelectSortOptionsFilter from './select-sort-option-filter'

export const coursesRouteMarketProductsInitialParams = {
  page: 1,
  size: 1000,
  categories: [],
}
export const coursesRouteMarketProductCategoriesInitialParams = {
  page: 1,
  size: 100,
}

type QueryType = {
  criteria: string
  categories: string | string[]
  orderBy?: string
  orderDirection?: 'asc' | 'desc'
}

interface CourseScreenProps {}
const CoursesScreen: React.FC<CourseScreenProps> = ({}) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const { query, updateQuery } = useQueryParams<QueryType>()

  const criteria = query?.criteria
  const categoriesFilter = query?.categories || []
  const orderBy = query?.orderBy
  const orderDirection = query?.orderDirection
  const selectedCategoriesId =
    typeof categoriesFilter === 'string' ? [categoriesFilter] : categoriesFilter

  const { data: marketProductsPage, isLoading } = useGetMarketProducts({
    ...coursesRouteMarketProductsInitialParams,
    criteria,
    categories: selectedCategoriesId,
    orderBy,
    orderDirection,
  })
  const marketProducts = marketProductsPage?.data
  const numberOfProducts = marketProducts?.length || 0

  const { data: categoriesPage, isLoading: loadingCategories } =
    useGetAllMarketProductCategories(
      coursesRouteMarketProductCategoriesInitialParams
    )
  const categories = categoriesPage?.data

  const selectedCategories = categories?.filter((category) =>
    selectedCategoriesId.includes(category._id)
  )

  const handleCategoriesChange = (categories: MarketProductCategoryType[]) => {
    const categoriesId = categories.map((category) => category._id)
    // console.log({ categoriesId })
    updateQuery({ categories: categoriesId })
  }
  return (
    <Webpage title="Lista de Cursos">
      <Header />
      <NavBar active="courses" />
      <Body className="h-full">
        <Row className="w-full items-center justify-between border-t border-indigo-50 bg-white py-3 sm:border-0 lg:hidden">
          <Container className="flex flex-row items-center justify-between space-x-sm">
            <SearchInput placeholder="Agente" />
            <IconButton
              icon={FilterIcon}
              onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
              intent="ghost"
              size="md"
            />
          </Container>
        </Row>
        <Row className="container mx-auto flex-1">
          <Column
            className={classNameBuilder(
              'hidden max-w-[380px] flex-1 py-md lg:flex lg:max-w-[408px] lg:px-md xl:px-xl',
              ' bg-indigo-700  '
            )}
          >
            <CheckboxList
              value={selectedCategories}
              onChange={handleCategoriesChange}
              pending={loadingCategories}
              options={categories}
            />
          </Column>
          <Column className="flex-1 px-md py-md xl:px-xl">
            <Row className="items-center justify-between">
              <Text className="text-base font-bold text-black">
                {numberOfProducts} Resultados Encontrados
              </Text>
              <Row className="hidden items-center md:flex">
                <Text className="whitespace-nowrap pr-2 text-xs font-bold uppercase opacity-50">
                  Ordenar por
                </Text>
                <SelectSortOptionsFilter className="max-w-[240px]" />
              </Row>
            </Row>
            <CoursesGrid marketProducts={marketProducts} pending={isLoading} />
            <SearchFiltersModal
              className="lg:hidden"
              open={isOpen}
              onClose={() => setIsOpen(false)}
              value={selectedCategories}
              onChange={handleCategoriesChange}
              pending={loadingCategories}
              options={categories}
            />
          </Column>
        </Row>
      </Body>
      <Footer />
    </Webpage>
  )
}

export default CoursesScreen
